import { CodeListStatus } from "@gtpl/shared-models/common-models";

export class CodeListDataDto {
    codeListLogId: number;
    saleOrderId: number;
    saleOrderItemId: number;
    code: string;
    cartons: number;
    productionDate: string;
    bestBeforeDate: string;
    unitId: number;
    codeListStatus: CodeListStatus;
    poNumber: string;

    constructor(
        codeListLogId: number,
        saleOrderId: number,
        saleOrderItemId: number,
        code: string,
        cartons: number,
        productionDate: string,
        bestBeforeDate: string,
        unitId: number,
        codeListStatus: CodeListStatus,
        poNumber: string
    ) {
        this.codeListLogId = codeListLogId;
        this.saleOrderId = saleOrderId;
        this.saleOrderItemId = saleOrderItemId;
        this.code = code;
        this.cartons = cartons;
        this.productionDate = productionDate;
        this.bestBeforeDate = bestBeforeDate;
        this.unitId = unitId;
        this.codeListStatus = codeListStatus;
        this.poNumber = poNumber;
    }
}
